import {Injectable} from '@angular/core';
import {HttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FileService {

  constructor(private http: HttpClient) {}

  downloadFile(url): Observable<any>{	
    return this.http.get(environment.apiEndpoint+url, { headers: new HttpHeaders({
        'Authorization': '{data}',
        'Content-Type': 'application/json',
      }), responseType: 'blob'}).pipe (
        map(res => {
            return res;
        })
     );
   }   
}